import { render, staticRenderFns } from "./CheckoutThankyou.vue?vue&type=template&id=613addb6&scoped=true&"
import script from "./CheckoutThankyou.vue?vue&type=script&lang=js&"
export * from "./CheckoutThankyou.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutThankyou.vue?vue&type=style&index=0&id=613addb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613addb6",
  null
  
)

export default component.exports